import React from 'react';

import { PageTitle } from 'src/components/Layout/PageTitle';

import { TwoCol } from '../Layout';
import { RichText } from '../RichText/RichText';

import { CmsPageInnerProps } from './CmsPageInner';

export function CmsLayoutSidebar(props: CmsPageInnerProps) {
    return (
        <>
            {props.content_heading && <PageTitle title={props.content_heading} />}
            <div>
                <TwoCol right="..." main={<RichText content={props.content} />} />
            </div>
        </>
    );
}
